// src/pages/HospitalityScenario.jsx
import React, { useState } from 'react';
// Import Link if using React Router for internal navigation
// import { Link } from 'react-router-dom';

const HospitalityScenario = () => {
    // State to hold answers and feedback for each question
    const [answers, setAnswers] = useState({});
    const [feedback, setFeedback] = useState({});

    // Navigation Links Data
    const navLinks = [
      
    ];

    // Scenario Questions Data
    const scenarios = [
        { id: 'q1', title: 'A guest says their room is too noisy. How do you respond?', prompt: 'How do you show empathy? What solutions can you offer?' },
        { id: 'q2', title: 'A guest is upset because their reservation was lost. How do you resolve this?', prompt: 'How do you apologize? Can you offer an upgrade?' },
        { id: 'q3', title: 'A guest demands a refund for a service they used. How do you handle this?', prompt: 'How do you stay polite but firm?' },
        { id: 'q4', title: 'A guest asks for a late checkout. How do you respond?', prompt: 'What factors do you consider? Can you charge a fee?' },
        { id: 'q5', title: 'A guest complains about the breakfast quality. How do you respond?', prompt: 'How do you investigate and reassure?' },
        { id: 'q6', title: 'You receive a report of smoke on the 8th floor. What are your immediate actions?', prompt: 'Who do you inform? Do you evacuate?' },
        { id: 'q7', title: 'A guest collapses in the lobby. How do you respond?', prompt: 'What is your first call? How do you speak to other guests?' },
        { id: 'q8', title: 'A fire alarm goes off at 3 AM. What is your procedure?', prompt: 'How do you verify? When do you announce evacuation?' },
        { id: 'q9', title: 'A guest claims they were overcharged on their bill. How do you resolve this?', prompt: 'How do you verify? How do you communicate the result?' },
        { id: 'q10', title: 'A VIP guest is arriving, but their suite isn’t ready. How do you manage this?', prompt: 'How do you buy time? Can you offer compensation?' },
        // Add more scenarios up to Q30 if needed
    ];

    const handleInputChange = (id, value) => {
        setAnswers(prev => ({ ...prev, [id]: value }));
    };

    const submitAnswer = (id) => {
        const value = answers[id] || '';
        let feedbackText = '';
        if (value.trim().length < 20) {
            feedbackText = "<strong>💡 Tip:</strong> Be specific. Include tone, procedure, and guest care considerations in your response.";
        } else {
            feedbackText = "<strong>✅ Well done!</strong> Your response addresses the scenario. Consider reviewing best practices for comparison."; // Adjusted feedback
        }
        setFeedback(prev => ({ ...prev, [id]: feedbackText }));
    };

    // --- Inline Styles (Derived from CSS) ---
    const bodyStyle = {
      fontFamily: "'Segoe UI', sans-serif",
      background: '#f7f9fc',
      color: '#2c3e50',
      lineHeight: 1.6,
      minHeight: '100vh',
    };
    const headerStyle = {
      textAlign: 'center',
      padding: '40px 20px',
      background: '#1a362d', // Dark green
      color: '#d4af37', // Gold
    };
    const headerH1Style = {
      fontSize: '28px',
      textShadow: '1px 1px 2px rgba(0,0,0,0.4)',
    };
     const headerNavStyle = { marginTop: '20px' };
     const headerNavUlStyle = { listStyle: 'none', display: 'flex', justifyContent: 'center', gap: '20px', padding: 0 };
     const headerNavLinkStyle = { color: 'white', textDecoration: 'none', fontWeight: 'bold' };
     // Hover handled via JS for simplicity here

    const containerStyle = {
      maxWidth: '900px',
      margin: '40px auto',
      padding: '30px',
      background: 'white',
      borderRadius: '12px',
      boxShadow: '0 6px 20px rgba(0,0,0,0.1)',
    };
    const h2Style = { margin: '20px 0 10px', color: '#1a362d' };
    const h3Style = { margin: '20px 0 10px', color: '#1a362d' };
    const pUlOlStyle = { margin: '10px 0' };
    const btnStyle = {
      display: 'inline-block',
      padding: '10px 20px',
      background: '#d4af37', // Gold
      color: '#1a362d', // Dark green
      border: 'none',
      borderRadius: '6px',
      cursor: 'pointer',
      margin: '10px 0',
      fontSize: '14px',
      fontWeight: 'bold',
      boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
    };
     const textAreaStyle = {
      width: '100%',
      padding: '10px',
      margin: '10px 0',
      border: '1px solid #ddd',
      borderRadius: '6px',
      fontFamily: 'inherit',
      minHeight: '80px', // Added min height
    };
    const exerciseStyle = {
      background: '#f8f9fa',
      padding: '20px',
      margin: '20px 0',
      borderLeft: '4px solid #d4af37', // Gold border
      borderRadius: '6px',
    };
    const feedbackStyle = {
      margin: '10px 0',
      padding: '10px',
      background: '#e8f4f8',
      borderRadius: '6px',
      fontSize: '0.9em', // Slightly smaller feedback text
    };
     const footerStyle = { textAlign: 'center', padding: '20px', background: '#1a362d', color: '#d4af37', marginTop: '40px'};
     const footerNavLinksStyle = { marginBottom: '15px'};
     const footerNavLinkStyle = { margin: '0 10px', color: '#d4af37', textDecoration: 'none', fontWeight: 'bold' };


    return (
        <div style={bodyStyle}>
            <header style={headerStyle}>
                {/* Header Navigation */}
                <nav style={headerNavStyle}>
                  <ul style={headerNavUlStyle}>
                      {navLinks.map(link => (
                          <li key={link.label}>
                              <a href={link.href} style={headerNavLinkStyle}
                                 onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                                 onMouseLeave={(e) => e.target.style.textDecoration = 'none'}>
                                  {link.label}
                              </a>
                          </li>
                      ))}
                  </ul>
                </nav>
                <h1 style={headerH1Style}>🏨 Professional Practice Scenarios: Hotel & Hospitality Professionals</h1>
                <p>Solve real operational challenges using English as your tool.</p>
            </header>

            <div style={containerStyle}>
                <h2 style={h2Style}>🎯 After completing this lesson, you will be able to:</h2>
                <ul style={pUlOlStyle}>
                    <li>Handle difficult guests with professionalism.</li>
                    <li>Lead during emergencies like fires or medical incidents.</li>
                    <li>Communicate clearly with staff, guests, and emergency services.</li>
                    <li>Protect both safety and reputation under public pressure.</li>
                </ul>

                {/* Scenarios */}
                <h2 style={h2Style}>Part 1: Guest Service & Communication</h2>
                {scenarios.slice(0, 5).map(scenario => ( // Displaying first 5 for Part 1
                    <div key={scenario.id} style={exerciseStyle}>
                        <h3 style={h3Style}>{scenario.title}</h3>
                        <p style={pUlOlStyle}><strong>Think about:</strong> {scenario.prompt}</p>
                        <textarea
                            id={scenario.id}
                            style={textAreaStyle}
                            placeholder="Your response..."
                            value={answers[scenario.id] || ''}
                            onChange={(e) => handleInputChange(scenario.id, e.target.value)}
                        />
                        <button onClick={() => submitAnswer(scenario.id)} style={btnStyle}>✅ Submit</button>
                        {feedback[scenario.id] && (
                            <div style={feedbackStyle} dangerouslySetInnerHTML={{ __html: feedback[scenario.id] }}></div>
                        )}
                    </div>
                ))}

                 <h2 style={h2Style}>Part 2: Safety & Emergency Response</h2>
                 {scenarios.slice(5, 10).map(scenario => ( // Displaying next 5 for Part 2
                    <div key={scenario.id} style={exerciseStyle}>
                        <h3 style={h3Style}>{scenario.title}</h3>
                        <p style={pUlOlStyle}><strong>Think about:</strong> {scenario.prompt}</p>
                        <textarea
                            id={scenario.id}
                            style={textAreaStyle}
                            placeholder="Your response..."
                            value={answers[scenario.id] || ''}
                            onChange={(e) => handleInputChange(scenario.id, e.target.value)}
                        />
                        <button onClick={() => submitAnswer(scenario.id)} style={btnStyle}>✅ Submit</button>
                        {feedback[scenario.id] && (
                            <div style={feedbackStyle} dangerouslySetInnerHTML={{ __html: feedback[scenario.id] }}></div>
                        )}
                    </div>
                ))}
                {/* Add more sections/scenarios if needed */}

            </div>

            <footer style={footerStyle}>
                {/* Footer Navigation */}
                <nav style={footerNavLinksStyle}>
                   {navLinks.map(link => (
                          <a key={link.label} href={link.href} style={footerNavLinkStyle}
                             onMouseEnter={(e) => e.target.style.color = 'white'}
                             onMouseLeave={(e) => e.target.style.color = '#d4af37'}>
                              {link.label}
                          </a>
                      ))}
                </nav>
                 <p>&copy; 2025 Aulice Academy.</p>
            </footer>
        </div>
    );
};

export default HospitalityScenario;

